import { z } from "zod";

export const loginSchema = z.object({
	email: z.string().min(1, "Email is required").email("Invalid email address"),
	password: z.string().min(1, "Password is required"),
});

export type LoginFormData = z.infer<typeof loginSchema>;

export const forgotPasswordSchema = z.object({
	email: z.string().min(1, "Enter your email address").email("Invalid email"),
});

export type ForgotPasswordFormData = z.infer<typeof forgotPasswordSchema>;

export const confirmResetSchema = z
	.object({
		resetCode: z.string().min(1, "Enter the code from your email"),
		newPassword: z.string().min(8, "Password must be at least 8 characters"),
		confirmPassword: z.string().min(1, "Confirm password is required"),
	})
	.refine((data) => data.newPassword === data.confirmPassword, {
		message: "Passwords do not match",
		path: ["confirmPassword"],
	});

export type ConfirmResetFormData = z.infer<typeof confirmResetSchema>;

export const newPasswordRequiredSchema = z
	.object({
		newPassword: z.string().min(8, "Password must be at least 8 characters"),
		confirmPassword: z.string().min(1, "Confirm password is required"),
	})
	.refine((data) => data.newPassword === data.confirmPassword, {
		message: "Passwords do not match",
		path: ["confirmPassword"],
	});

export type NewPasswordRequiredFormData = z.infer<
	typeof newPasswordRequiredSchema
>;
